import { OperationType } from "common/constants/sm-constants";

export class ResolverResponseModel {
    data!: DataModel;
    meta: any;
    widget!: WidgetModel;
}

export class APIConfig {
    CREATE : 'api/save';
    CREATEALTERNATE : 'save';
    READ : 'getall';
    UPDATE : 'getbyid';
    DELETE : 'api/delete';
    SYSTEMKEY : '';
    // GETBYPARENT : 'getbyparentid';
    // VALIDATE : 'validate'
}

export class RouteEnvelope {
    type!: OperationType;
    transferData: any;
}

export class DataModel {
    id: string | number = 0;
}

export class MetaModel {
    pageTitle!: string;
    redirectPath!: string;
    properties: any;
    isStepForm!:boolean;
}

export class WidgetModel {
    transferData: any;
}

export class QueryParams {
    id: any = 0;
    type: OperationType = OperationType.VIEW;
}

export class CommonModel<T extends DataModel, M extends MetaModel> {}
